import React from 'react';
import { Typography } from 'seagull';
import WithLegendDot from "../WithLegendDot/WithLegendDot";
import { chartColors } from "../chartColors";
import styles from "./CustomTooltip.module.scss";
/**
 * Renders a tooltip to be used in recharts graphs using the recharts Tooltip component
 * with "content" prop.
 */
export default function CustomTooltip(props) {
  const {
    active,
    payload,
    label,
    testid,
    getItems,
    getTitle
  } = props;
  const hasRelevantPayload = payload === null || payload === void 0 ? void 0 : payload.some(p => !!p.value);
  const title = getTitle ? getTitle(label) : label;
  const items = getItems(payload === null || payload === void 0 ? void 0 : payload.filter(p => p.value)) || [];
  return active && hasRelevantPayload && items.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": testid
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "secondary"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.separator
  }), items.map((_ref, idx) => {
    let {
      id,
      label,
      color,
      dataKey,
      inBrackets
    } = _ref;
    return /*#__PURE__*/React.createElement(WithLegendDot, {
      key: id,
      color: color || chartColors.lightGray,
      "data-testid": testid && "".concat(testid, "-item-").concat(idx),
      "data-key": dataKey
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph2"
    }, label, inBrackets && /*#__PURE__*/React.createElement(Typography, {
      as: "span",
      variant: "paragraph2",
      skin: "secondary"
    }, ' ', "(", inBrackets, ")")));
  })) : null;
}